import type { UseSuspenseQueryResult } from "@tanstack/react-query";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import { BaseSchemas } from "api-types";
import { useCustomerAppConfig } from "undercarriage";

interface BankingMembershipConfigResponse {
  show_waitlist: boolean;
  show_application: boolean;
  has_completed_mfa_setup: boolean;
}
export const CUSTOMER_BANKING_MEMBERSHIP_CONFIG_QUERY_KEY = "customer-banking-membership-config";
const CUSTOMER_BANKING_MEMBERSHIP_CONFIG_ENDPOINT = "/:customerSlug/banking/membership-config";

export const useGetBankingMembershipConfigQuery = (): UseSuspenseQueryResult<BankingMembershipConfigResponse> => {
  const client = useAxios();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  const requestPath = CUSTOMER_BANKING_MEMBERSHIP_CONFIG_ENDPOINT.replace(":customerSlug", customerDomain);

  return useSuspenseQuery({
    queryKey: [CUSTOMER_BANKING_MEMBERSHIP_CONFIG_QUERY_KEY, requestPath],
    queryFn: () => client.get<{ data: BankingMembershipConfigResponse }>(requestPath),
    select: ({ data }) => data.data,
  });
};

export const useIsBankingCustomer = (): {
  isBankingCustomer: boolean;
  hasCompletedMfaSetup: boolean;
} => {
  const { data } = useGetBankingMembershipConfigQuery();
  return {
    isBankingCustomer: data.show_application ?? false,
    hasCompletedMfaSetup: data.has_completed_mfa_setup ?? false,
  };
};

export const useHasPermissions = (permissions: BaseSchemas.CompanyPermission[]): boolean => {
  const {
    data: { userPermissions },
  } = useCustomerAppConfig();
  return permissions.every((permission) => userPermissions.includes(permission));
};
